(function () {
  // Tabla de días laborables según cantidad (dias hasta que el pedido esta listo para entrega)
  var RANGOS_DIAS = [
    { min: 1, max: 2, dias: 3 },
    { min: 3, max: 5, dias: 3 },
    { min: 6, max: 11, dias: 4 },
    { min: 12, max: 23, dias: 4 },
    { min: 24, max: 35, dias: 6 },
    { min: 36, max: 47, dias: 7 },
    { min: 48, max: 59, dias: 8 },
    { min: 60, max: 71, dias: 9 },
    { min: 72, max: 83, dias: 10 },
    { min: 84, max: 99, dias: 11 },
    { min: 100, max: 119, dias: 12 },
    { min: 120, max: 139, dias: 13 },
    { min: 140, max: 159, dias: 14 },
    { min: 160, max: 179, dias: 15 },
    { min: 180, max: 200, dias: 16 }
  ];

  /* ---------------------------------------------------------------------
     FERIADOS

     Antes habia una lista fija SOLO de 2026. El 1 de enero de 2027 la funcion
     habria dejado de excluir feriados sin avisar, y la tienda habria empezado a
     prometer fechas de entrega imposibles justo en temporada alta.

     Ahora se calculan para cualquier año: los de fecha fija mas los que dependen
     de la Pascua (Carnaval = Pascua-48/-47, Viernes Santo = Pascua-2).

     OJO: NO se aplica la regla de traslado de la Ley de Feriados (un feriado en
     martes se mueve al lunes anterior, en miercoles/jueves al viernes siguiente,
     etc.). Se excluye siempre la fecha base. El efecto es conservador: como
     mucho la estimacion se corre un dia hacia adelante, nunca hacia atras, que
     es el lado seguro para una promesa de entrega. Si quieres exactitud, añade
     los traslados del año en FERIADOS_EXTRA.
     --------------------------------------------------------------------- */

  // Fechas puntuales que quieras forzar como no laborables (vacaciones del
  // taller, traslados oficiales, etc.). Formato 'YYYY-MM-DD'.
  var FERIADOS_EXTRA = [];

  var MES_DIA_FIJOS = [
    [1, 1],   // Año Nuevo
    [5, 1],   // Día del Trabajo
    [5, 24],  // Batalla de Pichincha
    [8, 10],  // Primer Grito de Independencia
    [10, 9],  // Independencia de Guayaquil
    [11, 2],  // Día de los Difuntos
    [11, 3],  // Independencia de Cuenca
    [12, 25]  // Navidad
  ];

  var cacheFeriados = {};

  // Algoritmo de Gauss/Meeus para el domingo de Pascua (calendario gregoriano).
  function domingoDePascua(anio) {
    var a = anio % 19;
    var b = Math.floor(anio / 100);
    var c = anio % 100;
    var d = Math.floor(b / 4);
    var e = b % 4;
    var f = Math.floor((b + 8) / 25);
    var g = Math.floor((b - f + 1) / 3);
    var h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4);
    var k = c % 4;
    var l = (32 + 2 * e + 2 * i - h - k) % 7;
    var m = Math.floor((a + 11 * h + 22 * l) / 451);
    var mes = Math.floor((h + l - 7 * m + 114) / 31);
    var dia = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(anio, mes - 1, dia);
  }

  function feriadosDe(anio) {
    if (cacheFeriados[anio]) return cacheFeriados[anio];

    var set = {};
    MES_DIA_FIJOS.forEach(function (md) {
      set[formatearFechaISO(new Date(anio, md[0] - 1, md[1]))] = true;
    });

    var pascua = domingoDePascua(anio);
    [-48, -47, -2].forEach(function (delta) {   // Carnaval lunes y martes, Viernes Santo
      var f = new Date(pascua.getTime());
      f.setDate(f.getDate() + delta);
      set[formatearFechaISO(f)] = true;
    });

    FERIADOS_EXTRA.forEach(function (iso) {
      if (iso.indexOf(String(anio)) === 0) set[iso] = true;
    });

    cacheFeriados[anio] = set;
    return set;
  }

  var MESES = [
    'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
    'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'
  ];

  var MENSAJE_FUERA_DE_RANGO = 'Consulta tiempos de entrega';
  var DIAS_MARGEN_SEGUNDA_FECHA = 2;

  // Devuelve el numero de dias laborables para la cantidad, o null si la
  // cantidad esta fuera de la tabla (menor a 1 o mayor a 200).
  function obtenerDiasLaborables(cantidad) {
    var qty = parseInt(cantidad, 10);
    if (isNaN(qty) || qty < 1 || qty > 200) {
      return null;
    }
    for (var i = 0; i < RANGOS_DIAS.length; i++) {
      var rango = RANGOS_DIAS[i];
      if (qty >= rango.min && qty <= rango.max) {
        return rango.dias;
      }
    }
    return null;
  }

  function formatearFechaISO(fecha) {
    var y = fecha.getFullYear();
    var m = String(fecha.getMonth() + 1).padStart(2, '0');
    var d = String(fecha.getDate()).padStart(2, '0');
    return y + '-' + m + '-' + d;
  }

  /* El calculo tiene que partir del dia en Ecuador, no del dia del navegador:
     un cliente en Europa a las 02:00 veia la fecha corrida un dia. Ecuador
     continental es UTC-5 todo el año (no hay horario de verano). */
  function hoyEnEcuador() {
    var ahora = new Date();
    var utc = ahora.getTime() + ahora.getTimezoneOffset() * 60000;
    var ec = new Date(utc - 5 * 3600000);
    return new Date(ec.getFullYear(), ec.getMonth(), ec.getDate());
  }

  function esFeriadoOFinDeSemana(fecha) {
    var dia = fecha.getDay();
    if (dia === 0 || dia === 6) return true;
    return feriadosDe(fecha.getFullYear())[formatearFechaISO(fecha)] === true;
  }

  function sumarDiasLaborables(fechaInicio, diasHabiles) {
    var fecha = new Date(fechaInicio.getTime());
    var sumados = 0;
    var guarda = 0;
    while (sumados < diasHabiles && guarda < 400) {
      guarda++;
      fecha.setDate(fecha.getDate() + 1);
      if (!esFeriadoOFinDeSemana(fecha)) {
        sumados++;
      }
    }
    return fecha;
  }

  function sumarDiasCalendario(fechaInicio, dias) {
    var fecha = new Date(fechaInicio.getTime());
    fecha.setDate(fecha.getDate() + dias);
    return fecha;
  }

  function formatearFechaLegible(fecha) {
    return fecha.getDate() + ' de ' + MESES[fecha.getMonth()];
  }

  /* La cantidad se lee EN EL MOMENTO de actualizar, nunca se cachea el input:
     Dawn reemplaza el input de cantidad al cambiar de variante y una referencia
     guardada quedaria apuntando a un nodo huerfano. */
  function leerCantidad(bloque) {
    var sectionId = bloque.getAttribute('data-section-id');
    var input = sectionId ? document.getElementById('Quantity-' + sectionId) : null;
    if (input && input.value !== '') return input.value;

    // Respaldo: el stepper propio del bloque "Elige la Cantidad".
    var propio = document.querySelector('.epl-bulk .epl-bulk__input');
    if (propio && propio.value !== '') return propio.value;

    return null;
  }

  function actualizarBloque(bloque) {
    var destino = bloque.querySelector('[data-tiempo-entrega-fecha]');
    if (!destino) return;

    var cantidad = leerCantidad(bloque);
    if (cantidad === null) return;

    var dias = obtenerDiasLaborables(cantidad);

    if (dias === null) {
      destino.textContent = MENSAJE_FUERA_DE_RANGO;
      return;
    }

    var fechaInicio = sumarDiasLaborables(hoyEnEcuador(), dias);
    var fechaFin = sumarDiasCalendario(fechaInicio, DIAS_MARGEN_SEGUNDA_FECHA);

    destino.textContent = formatearFechaLegible(fechaInicio) + ' - ' + formatearFechaLegible(fechaFin);
  }

  function actualizarTodos() {
    Array.prototype.forEach.call(
      document.querySelectorAll('[data-tiempo-entrega]'),
      actualizarBloque
    );
  }

  /* Antes los listeners se enganchaban una sola vez, directamente sobre el
     input de cantidad. Al cambiar de variante Dawn reemplaza ese input por uno
     nuevo y los listeners se perdian: la fecha se quedaba congelada en el
     ultimo valor. Ahora se escucha en `document` (fase de captura), asi que
     funciona sin importar cuantas veces se regenere el input. */
  function esInputDeCantidad(el) {
    if (!el || el.tagName !== 'INPUT') return false;
    if (el.id && el.id.indexOf('Quantity-') === 0) return true;
    if (el.name === 'quantity') return true;
    return !!(el.classList && el.classList.contains('epl-bulk__input'));
  }

  function onPosibleCambio(event) {
    if (esInputDeCantidad(event.target)) actualizarTodos();
  }

  function iniciar() {
    actualizarTodos();
  }

  document.addEventListener('input', onPosibleCambio, true);
  document.addEventListener('change', onPosibleCambio, true);
  // El editor de temas y las apps recargan secciones enteras.
  document.addEventListener('shopify:section:load', actualizarTodos);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();
